import { ServerMessagePayload } from '@common/api';
import { SceneChangedEvent } from '@common/events';

import { ClientEventSystem } from './ClientBase';

/**
 * Handles the transition when the player's scene changes.
 * - Resets the world (destroys all entities, clears ID mappings)
 * - Requests scene data from server if missing
 */
export class SceneTransitionSystem extends ClientEventSystem<'SceneChanged'> {
  public eventTypes: 'SceneChanged'[] = ['SceneChanged'];

  handleEvent(event: SceneChangedEvent): ServerMessagePayload[] {
    const { newSceneId } = event.payload;

    const localPlayerService = this.clientServices.localPlayer;
    const mapDataService = this.clientServices.common.mapData;
    const connectionService = this.clientServices.connection;

    // DON'T call resetWorld()! The server has already sent:
    // 1. WorldSync with entities for the new scene
    // 2. WhoAmI telling us which entity is ours
    // Calling resetWorld() would destroy that fresh data.

    // Just request the scene/map data if we don't have it
    const playerId = localPlayerService.playerId;
    const mapId = mapDataService.getSceneMapId(newSceneId);

    if (!mapId || !mapDataService.getMap(mapId)) {
      if (playerId !== undefined) {
        connectionService.send({
          playerId,
          payload: [
            {
              type: 'requestScene',
              sceneId: newSceneId,
            },
          ],
        });
      }
    }

    return [];
  }
}
